export default __webpack_public_path__ + "static/media/watchMenu.17d1d219.png";